import PersonPinIcon from '@material-ui/icons/PersonPin';

export const Agent: object = {
  icon: PersonPinIcon,
};

export default Agent;